BaseModel = require './base_model.coffee'

class global.VoipCall extends BaseModel
  @ATTRIBUTES =
    id: {}
    status: {}



// WEBPACK FOOTER //
// ./src/models/voip_call.coffee